import React from "react";
import heroImage from "../../assets/images/appImages/heroimage.jpg";
import { NavLink } from 'react-router-dom';

interface HeroSectionProps {
  eyebrow?: string;
  title?: React.ReactNode;
  paragraphs?: string[];
  quoteAuthor?: string;
  ctaLabel?: string;
  ctaHref?: string;
  imageSrc?: string;
  imageAlt?: string;
}

const HeroSection: React.FC<HeroSectionProps> = ({
  eyebrow = "Le savoir au service de la personne",
  title = (
    <>
      Une quête permanente du <br className="d-none d-lg-block" />
      savoir
    </>
  ),
  paragraphs = [
    "Guidé par la volonté d'apprendre, de transmettre et de mieux accompagner, Ahmad Ba a construit son parcours autour de la médecine prophétique, de la phytothérapie et des pratiques complémentaires.",
    "Son parcours l'a conduit jusqu'en Égypte pour approfondir ses connaissances. Aujourd'hui encore, il poursuit ses apprentissages afin de faire évoluer sa pratique avec sérieux et responsabilité.",
  ],
  quoteAuthor = "Ahmad Ba, Fondateur de Fouta Bio",
  ctaLabel = "Découvrir son parcours",
  ctaHref = "#",
  imageSrc = heroImage,
  imageAlt = "Tasse de tisane entourée de plantes et de fleurs séchées",
}) => {
  return (
    <section className="hero-section py-5 py-lg-6">
      <div className="container-xl">
        <div className="row align-items-center gy-5">
          {/* Colonne texte */}
          <div className="col-lg-6">
            <p className="hero-eyebrow mb-3">{eyebrow}</p>

            <h1 className="hero-title mb-4">{title}</h1>

            {paragraphs.map((p, i) => (
              <p key={i} className="hero-text mb-3">
                {p}
              </p>
            ))}

            <p className="hero-quote mt-4 mb-4">— {quoteAuthor}</p>

           <NavLink to="/about" className="hero-cta">
    {ctaLabel} <span className="hero-cta-arrow">→</span>
</NavLink>
          </div>

          {/* Colonne image */}
          <div className="col-lg-6">
            <div className="hero-image-frame">
              <img src={imageSrc} alt={imageAlt} className="hero-image" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;